import { Component } from "@angular/core";
import { TabModel } from "@models/generic/TabModels/TabModel";
import { MenuSystemDirective } from "@app/shared/directives/menu-system.directive";
import { JobSchedulerListComponent } from "./components/job-scheduler-list/job-scheduler-list.component";

@Component({
    selector: "job-scheduler-status",
    templateUrl: "./job-scheduler-status.component.html",
    styleUrls: ["./job-scheduler-status.component.scss"],
    imports: [MenuSystemDirective, JobSchedulerListComponent],
})
export class JobSchedulerStatusComponent {
    tab: TabModel;
}
